import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import 'firebase/messaging';

import { useDispatch, useSelector } from 'react-redux';

import { ContainerProducts, Root } from './styles';

import ProductList from '../../components/ProductList';
import { customerClear } from '../../store/modules/auth/actions';
import { setIsCategory } from '../../store/modules/parameter/actions';
import { StoreState } from '../../store/createStore';

import { config } from '../../config';
import HeroBanner from '../../components/HeroBanner';

type StateType = {
  isPrivate: string;
  pathAfterLogin: string;
  pathname: string;
};

type HomeProps = RouteComponentProps<StateType>;

const Home: React.FC<HomeProps> = () => {
  const dispatch = useDispatch();
  const { multistoreSelected } = useSelector((state: StoreState) => state.parameter);
  const { components } = useSelector((state: StoreState) => state.category);

  useEffect(() => {
    dispatch(setIsCategory(true));
  }, [dispatch]);

  useEffect(() => {
    dispatch(customerClear());
  }, [dispatch]);

  if (config.isAllowedMultistore && !multistoreSelected.store_id) {
    return null;
  }

  return (
    <Root>
      <ContainerProducts>
        {
          (components.data[components.categoryCurrentId] || []).length > 0 && components.data[components.categoryCurrentId].map(heroBanner => <HeroBanner key={heroBanner.id} data={heroBanner}/>)
        }
        <ProductList />
      </ContainerProducts>
    </Root>
  );
};

export default withRouter(Home);
